module.exports = __webpack_public_path__ + "static/media/que-vendemos.ffcf9109.png";